import React from "react";
import "../../app/style/header-footer-rebrand-responsive.css";
import { SMARTBRIEF_ROOT } from "../constants";

export function AppFooter() {
    return (
        <footer>
            <div className="footer-top">
                <div className="footer-top-container">
                    <div className="footer-logos-social">
                        <div className="footer-smartbrief-logos">
                            <div className="footer-smartbrief-logo"></div>
                            <div>
                                <div className="footer-smart-logo"></div>
                                <div className="footer-brief-logo"></div>
                            </div>
                        </div>
                        <div className="footer-social-content">
                            <div>A Future Publishing business.</div>
                            <div className="footer-social-logos">
                                <a
                                    className="footer-facebook-logo"
                                    href="https://www.facebook.com/smartbrief"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {" "}
                                </a>
                                <a
                                    className="footer-x-logo"
                                    href="https://twitter.com/smartbrief"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {" "}
                                </a>
                                <a
                                    className="footer-linkedin-logo"
                                    href="https://www.linkedin.com/company/smartbrief/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {" "}
                                </a>
                                <a
                                    className="footer-youtube-logo"
                                    href="https://www.youtube.com/channel/UCak68OlraOWKzomvFK2Xceg"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {" "}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="link-row">
                        <div className="footer-link-column">
                            <div className="footer-link-column-header text-SM-regular bold">About</div>
                            <div className="footer-links text-MD-regular">
                                <a href={`${SMARTBRIEF_ROOT}/about-us`}>About us</a>
                                <a href={`${SMARTBRIEF_ROOT}/contact-us`}>Contact</a>
                                <a href={`${SMARTBRIEF_ROOT}/write-for-us`}>Write for us</a>
                                <a href={`${SMARTBRIEF_ROOT}/careers`}>Careers</a>
                            </div>
                        </div>
                        <div className="footer-link-column">
                            <div className="footer-link-column-header text-SM-regular bold">Publications</div>
                            <div className="footer-links text-MD-regular">
                                <a href={`${SMARTBRIEF_ROOT}/subscriptions`}>Newsletters</a>
                                <a href={`${SMARTBRIEF_ROOT}/articles`}>Insights & Analysis</a>
                            </div>
                        </div>
                    </div>
                    <div className="link-row">
                        <div className="footer-link-column">
                            <div className="footer-link-column-header text-SM-regular bold">Advertising</div>
                            <div className="footer-links text-MD-regular">
                                <a href={`${SMARTBRIEF_ROOT}/partner`}>Partnerships</a>
                                <a href={`${SMARTBRIEF_ROOT}/resources`}>Marketing Resources</a>
                                <a href={`${SMARTBRIEF_ROOT}/ad-specs`}>Advertising Specs</a>
                                <a href={`${SMARTBRIEF_ROOT}/smartstudio`}>SmartStudio</a>
                            </div>
                        </div>
                        <div className="footer-link-column">
                            <div className="footer-link-column-header text-SM-regular bold">Legal</div>
                            <div className="footer-links text-MD-regular">
                                <a
                                    href="https://www.futureplc.com/terms-conditions/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-terms-conditions"
                                >
                                    Terms of Use
                                </a>
                                <a href={`${SMARTBRIEF_ROOT}/privacy-cookie-policy`}>Privacy & Cookies Policy</a>
                                <a
                                    href="https://www.futureplc.com/privacy-policy/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-privacy-policy"
                                >
                                    California Privacy Rights
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="copyright-notice text-SM-regular">
                    <div>&copy; Copyright notice 2023. All rights reserved.</div>
                    <div>A division of Future US LLC, Full 7th Floor, 130 West 42nd Street, New York, NY, 10036.</div>
                </div>
            </div>
        </footer>
    );
}
